module.exports = __webpack_public_path__ + "static/media/pdf.c94e9cc8.svg";